export const ROLES = {
  USER_ROLE: 'USER',
  ADMIN_ROLE: 'ADMIN',
  SUPER_ADMIN_ROLE: 'SUPER_ADMIN',
};

export default ROLES;
